import { useTaskDialogStore } from './useTaskDialogStore';

export function useOpenTask() {
  return useTaskDialogStore((s) => s.openTask);
}
